import React from 'react';
import { fromJS, List } from 'immutable';
import { Field, Fields } from 'redux-form/immutable';
import PropTypes from 'prop-types';

import FormDateWithStartAndEnd from 'retired/FormDateWithStartAndEnd';
import FormSelectBoxEntitySelector from 'retired/FormSelectBoxEntitySelector';
import { currencies } from 'utils/currencyFormat';
import { Features } from 'utils/features';

const currencyCodes = Object.keys(currencies);
export const filterOptions = [
  { id: '0', name: 'One-Time' },
  { id: 'P', name: 'Recurring' },
  { id: 'P1M', name: 'Monthly' },
];

export const paymentMethodOptions = (user) =>
  [
    { id: 'Card', name: 'Card' },
    { id: 'PayPal', name: 'PayPal' },
    { id: 'External', name: 'External' },
    (user?.hasFeature(Features.PAYROLL_API) || user?.hasFeature(Features.PAYROLL_FLAT_FILE)) && {
      id: 'Payroll',
      name: 'Payroll',
    },
    user?.hasFeature(Features.DONATION_CREDIT) && {
      id: 'DeedCredit',
      name: 'Deed Credit',
    },
    { id: 'Other', name: 'Other payments' },
  ].filter(Boolean);

export const paymentMethodOptionsCorporate = (user) =>
  [
    user?.hasFeature(Features.CORPORATE_DONATIONS) && {
      id: 'CorporateBudget',
      name: 'Corporate Budget',
    },
    user?.hasFeature(Features.EXTERNAL_CORPORATE_DONATIONS) && { id: 'External', name: 'External' },
  ].filter(Boolean);

const companyDonationOnUserBehalfProviderOptions = ['PayPal', 'NFG'];

export const providerOptions = [
  ...companyDonationOnUserBehalfProviderOptions,
  'GlobalGiving',
  'Stripe',
  'Betterplace',
  'DCGF',
  'External',
].filter(Boolean);

const DonationsFilter = ({ matchingEnabled, matchingMode, recurringEnabled, user, type }) => {
  const isCompanyDonationOnUserBehalf = type === 'company-donation-on-user-behalf';
  return (
    <form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginTop: 10,
      }}
    >
      <Fields
        names={['startingAt', 'endingAt']}
        component={FormDateWithStartAndEnd}
        style={{ marginRight: 10, marginBottom: 10, width: 252 }}
      />
      <Field
        name="currencies"
        component={FormSelectBoxEntitySelector}
        options={List(currencyCodes)}
        placeholder="Currency"
        multiple
        style={{ marginRight: 10, marginBottom: 10, width: 160 }}
      />
      <Field
        name="providers"
        component={FormSelectBoxEntitySelector}
        options={List(
          isCompanyDonationOnUserBehalf
            ? companyDonationOnUserBehalfProviderOptions
            : providerOptions
        )}
        placeholder="Processor"
        multiple
        style={{ marginRight: 10, marginBottom: 10, width: 252 }}
      />
      {matchingEnabled && !matchingMode && !isCompanyDonationOnUserBehalf && (
        <Field
          name="matched"
          component={FormSelectBoxEntitySelector}
          options={List(['Matched', 'Unmatched'])}
          placeholder="Filter matched / unmatched"
          multiple
          style={{ marginRight: 10, marginBottom: 10, width: 252 }}
        />
      )}
      {recurringEnabled && !isCompanyDonationOnUserBehalf && (
        <Field
          name="recurringFrequency"
          component={FormSelectBoxEntitySelector}
          options={fromJS(filterOptions)}
          placeholder="Filter by recurring frequency"
          multiple
          style={{ marginRight: 10, marginBottom: 10, width: 252 }}
        />
      )}
      {!isCompanyDonationOnUserBehalf && (
        <Field
          name="paymentMethod"
          component={FormSelectBoxEntitySelector}
          options={fromJS(
            type === 'corporate' ? paymentMethodOptionsCorporate(user) : paymentMethodOptions(user)
          )}
          placeholder="Filter by payment method"
          multiple
          style={{ marginRight: 10, marginBottom: 10, width: 252 }}
        />
      )}
    </form>
  );
};
DonationsFilter.propTypes = {
  matchingEnabled: PropTypes.bool,
  matchingMode: PropTypes.bool,
  recurringEnabled: PropTypes.bool,
  user: PropTypes.object,
  type: PropTypes.string,
};
export default DonationsFilter;
